import { getDisplayInfo } from "utils/formatting";
import { Table } from "components/molecules/Table";

interface QuickHorizontalTableProps {
    theObjs: any[];
    theKeyAttribute: string;
    showOnlyKeys?: string[];
}
export function QuickHorizontalTable({ theObjs, theKeyAttribute, showOnlyKeys }: QuickHorizontalTableProps) {
    const dataSource = theObjs.map((anObj) => {
        const key = anObj[theKeyAttribute];
        return {
            key,
            attribute: key,
            ...anObj,
        };
    });
    const genericRender = (value: any) => value;
    const attributeColumn = [
        {
            render: genericRender as Function,
            title: "Attribute" as string,
            key: "attribute",
        },
    ];

    const tableColumnKeys = showOnlyKeys || Object.keys(theObjs[0]);
    const dynamicColumns = tableColumnKeys.map((col) => {
        const values = theObjs?.map((d) => d[col]);
        try {
            const { unit, formatFunction, humanReadable } =
                theObjs && theObjs?.length > 0 && typeof theObjs[0][col] === "number"
                    ? getDisplayInfo(col, values)
                    : getDisplayInfo(col);

            return {
                render: formatFunction,
                title: `${humanReadable} ${unit && `(${unit})`}`,
                key: col,
            };
        } catch (error) {
            return {
                render: genericRender as Function,
                title: col as string,
                key: col,
            };
        }
    });
    dynamicColumns.sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }));
    const columns = attributeColumn.concat(dynamicColumns);
    return <Table dataSource={dataSource} columns={columns} />;
}

interface QuickVerticalTableProps {
    theObjs: any[];
    theKeyAttribute: string;
    showOnlyKeys?: string[];
}
export function QuickVerticalTable({ theObjs, theKeyAttribute, showOnlyKeys }: QuickVerticalTableProps) {
    const tableRowKeys = showOnlyKeys || Object.keys(theObjs[0]);
    const tableColumnKeys = theObjs.map((item) => `${item[theKeyAttribute]}`);
    const objsByKeyAttribute = theObjs.reduce((acc, item, index) => {
        acc[`${item[theKeyAttribute]}`] = item;
        return acc;
    }, {});

    const pivotedRows = tableRowKeys.map((rowKey) => {
        const pivotedObjs: { [key: string]: any } = {};
        tableColumnKeys.forEach((columnKey) => {
            const item = objsByKeyAttribute[columnKey];
            pivotedObjs[columnKey] = item[rowKey];
        });
        pivotedObjs.attribute = rowKey;
        return pivotedObjs;
    });

    const dataSource = pivotedRows.map((row) => ({
        key: row.attribute,
        ...row,
    }));
    const attributeColumn = [
        {
            render: (value: any) => value,
            key: "attribute",
            title: "Attribute",
        },
    ];

    const dynamicColumns = tableColumnKeys.map((columnKey) => ({
        render: (value: any) => value,
        key: columnKey,
        title: columnKey,
    }));
    dynamicColumns.sort((a, b) => a.title.localeCompare(b.title, undefined, { numeric: true }));

    const columns = attributeColumn.concat(dynamicColumns);

    return <Table dataSource={dataSource} columns={columns} />;
}
